<template>
  <div class="ai-friend-role-tag">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total"
      @change="loadData" @edit="edit" @add="add" @delete="deleteRow"></ConfigTable>
    <EditTemplateCategory ref="editDialog" @sure="callEdit"></EditTemplateCategory>
  </div>
</template>

<script>
import { Switch } from 'element-ui';
import { changeDate } from '../../../utils/filter';
import ConfigTable from '@/components/config-table';
import transApi from '../../../api/transactionManagement';
import EditTemplateCategory from './components/EditTemplateCategory.vue';
import { aiTemplateCategoryTypes } from './config';
import { getTypeLabel } from '../../../config';

const searchConfig = [
  { type: 'input', placeholder: '输入模版名称', key: 'name' },
  { type: 'select', placeholder: '选择模版类型', key: 'templateType', options: aiTemplateCategoryTypes },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
  { type: 'button', icon: 'plus', placeholder: '新增', key: 'add' },
]

const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '名称', key: 'name' },
  { name: '模版类型', key: 'templateType', valueHandler: (val) => getTypeLabel(val, aiTemplateCategoryTypes) },
  { name: '排序', key: 'rank' },
  {
    name: '是否启用', key: 'status', component: Switch, props(value) {
      return { value, disabled: true }
    }
  },
  {
    name: '创建时间', key: 'createdAt', valueHandler: changeDate
  },
  {
    name: '更新时间', key: 'updatedAt', valueHandler: changeDate
  },
  { name: '操作', fixed: 'right', actions: ['edit', 'delete'] },
];

export default {
  name: 'AiTemplateCategoryList',
  components: { ConfigTable, EditTemplateCategory },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      try {
        const r = await transApi.getAiTemplateCategoryList(params)
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        console.error('搜索ai角色标签失败：', error);
      }
    },
    add() {
      this.$refs.editDialog.open()
    },
    edit(row) {
      this.$refs.editDialog.open(row)
    },
    async deleteRow(row) {
      try {
        await this.$confirm("您确定要删除该条数据吗？", "操作提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        await transApi.delAiTemplateCategory({ id: row.id })
        this.$message.success('已删除')
        this.$refs.ct.search()
      } catch (error) {
        console.log(error);
      }
    },
    async callEdit(r) {
      try {
        console.log(r);
        await (r.isEdit ? transApi.updateAiTemplateCategory(r.data) : transApi.createAiTemplateCategory(r.data))
        this.$message.success(r.isEdit ? '更新成功' : '新增成功')
        this.$refs.editDialog.close()
        setTimeout(() => {
          this.$refs.ct.search()
        }, 200);
      } catch (error) {
        console.error('call edit error:', error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ai-friend-role-tag {

  /deep/ .el-button {
    padding: 9px 15px;
  }

  /deep/ .el-image {
    width: 100px;
    height: 100px;

    img {
      object-fit: contain;
    }
  }
}
</style>